// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

const Logo = (props: IconProps) => (
  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_1678_56)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8363 9.20568H12.4879V14.293H15.8363C17.446 14.293 18.5403 13.3696 18.5403 11.7601C18.5403 10.1503 17.446 9.20568 15.8363 9.20568ZM15.9647 16.3964H12.4879V22.4053H10.1699C10.1699 22.4053 10.1699 8.87741 10.1699 8.27914C10.1699 7.68064 10.737 7.12402 11.3588 7.12402C11.9803 7.12402 15.9647 7.12402 15.9647 7.12402C18.9484 7.12402 20.8587 9.09883 20.8587 11.7601C20.8587 14.4216 18.9484 16.3964 15.9647 16.3964Z"
        fill="#0D0D11"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.1713 22.4065L17.6557 17.3481C17.6557 17.3481 17.2638 17.5368 16.0781 17.5368C15.3879 17.5368 14.936 17.5368 14.936 17.5368L18.2868 22.4095L21.1713 22.4065Z"
        fill="#0D0D11"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.23488 15.0722C2.22669 11.881 3.24808 9.12854 5.33538 6.71492L3.645 5.253C1.19111 8.09019 -0.00946328 11.3262 -1.73676e-06 15.0773C0.021229 23.3398 6.73661 30.021 14.9986 30L14.993 27.7678C7.96488 27.7844 2.25277 22.1011 2.23488 15.0722Z"
        fill="#7ACFB3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.5709 16.7789C26.6978 23.1085 21.3842 27.7515 14.9949 27.7678L14.993 27.7678L14.9986 30C22.5091 29.9807 28.7548 24.5238 29.7811 17.0838L27.5709 16.7789Z"
        fill="#FBB209"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.8564 2.33192L21.678 4.22827L21.6798 4.2293C26.0202 6.9263 28.269 11.7167 27.5709 16.7789L29.7811 17.0838C30.602 11.1335 27.9585 5.502 22.8564 2.33192Z"
        fill="#69CEEA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.678 4.22827L22.8564 2.33192C19.0314 -0.0448875 14.8533 -0.583964 10.5504 0.74319L11.2092 2.87838L11.2104 2.87804C14.8703 1.74888 18.4244 2.20707 21.678 4.22827Z"
        fill="#81CC28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2092 2.87838L10.5504 0.74319C7.68461 1.6275 5.60677 2.98419 3.645 5.253L5.33538 6.71492C7.00408 4.78511 8.77177 3.63046 11.2092 2.87838Z"
        fill="#f15d23"
      />
    </g>
  </svg>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Icons/Logo.js